const defaultCorrectiveFactor = {
    id: '',
    factor_details: {},
    commercials: [],
    commercial_id_arr: [],
}

export default defaultCorrectiveFactor;